"use client";

// The only install reaching both the browser and the SSR pass over client components;
// instrumentation-client.ts is browser-only.
import "@offstreetparking/date-and-time/tzdata";
import { enableClientTracing } from "@offstreetparking/instrumentation/client";
import { env } from "~/env";
import { clientLogger } from "~/logger.client";

enableClientTracing({
	service: env.NEXT_PUBLIC_SERVICE,
	datadogApplicationId: env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
	datadogClientToken: env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
	environment: env.NEXT_PUBLIC_ENVIRO,
	version: env.NEXT_PUBLIC_COMMIT_SHA,
	apiUrl: env.NEXT_PUBLIC_API_URL,
	redactPersonalData: true,
	logger: clientLogger,
});

export const InstrumentationProvider = () => {
	return null;
};
